import chroma from 'chroma-js';

export interface IColorPalette {
    name: string;
    values: string[] ;
  }

export default class ColorPalette implements IColorPalette {
  name!: string;

  values!: string[];

  constructor(input?: unknown) {
    if (input) {
      Object.assign(this, input);
    }
  }

  hasCustomValues(): boolean {
    return Array.isArray(this.values) && this.values.length > 0 && !!this.values[0];
  }

  getColors(totalColors: number, reverse = false): string[] {
    let colors: string[];
    if (this.hasCustomValues()) {
      colors = chroma.scale(this.values).colors(totalColors);
    } else {
      colors = chroma.scale(this.name).colors(totalColors);
    }
    if (reverse) {
      colors = colors.reverse();
    }
    return colors;
  }

  getColorValue(i:number, totalColors:number,reverse=false):string {
    const colors = this.getColors(totalColors, reverse);
    return colors[i % totalColors];
  }
}
